import Vue from 'vue';
import orderTransformer from './../../transformers/order';
import store from './../../store';

const success = ({ data }, resolve) => {
  const order = orderTransformer.fetch(data);

  store.dispatch('fetchCurrentOrder', order);
  resolve(order);
};

const failed = (errors, reject) => {
  reject(orderTransformer.fetch(errors));
};

export default (id, order) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/orders/${id}`, orderTransformer.send(order))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/update.js